const messages = {
  en: {
    translations: {
      signup: {
        title: "Sign Up",
        toasts: {
          success: "User successfully created! Please log in!",
          disabled: "User registration is currently disabled. Please try again later.",
          fail: "Error creating user. Please check the provided data.",
          redirecting: "Redirecting to payment...",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          confirmPassword: "Confirm Password",
          passwordRequirements: "At least 8 characters, 1 uppercase, 1 number and 1 special character",
          company: "Organization Name",
          phone: "WhatsApp (with country code)",
          phoneHelper: "Ex: +1 555 999-9999",
          document: "CPF or CNPJ",
          documentHelper: "Enter CPF (11 digits) or CNPJ (14 digits)",
          plan: "Plan",
          paymentMethod: "Payment method",
          installments: "Installments",
          installmentsHelper: "Split the total into up to {{max}} installments on your credit card.",
          installmentsOption: "{{count}}x of R$ {{value}}",
          installmentsOptionSingle: "Pay in full — R$ {{value}}",
          planTotal: "Plan total: R$ {{value}}",
        },
        paymentOptions: {
          pix: "PIX",
          boleto: "Bank slip (Boleto)",
          card: "Credit card",
        },
        consent: {
          label: "I agree that my plan will automatically renew at the end of each period.",
        },
        buttons: {
          submit: "Register",
          login: "Already have an account? Log in!",
        },
        validation: {
          cpfValid: "Valid CPF!",
          cpfInvalid: "Invalid CPF! Please check the digits.",
          cnpjValid: "Valid CNPJ! Company name filled automatically.",
          cnpjInvalid: "Invalid CNPJ! Please check the digits.",
          cnpjNotFound: "CNPJ not found in the Federal Revenue.",
          cnpjWarning: "CNPJ valid, but could not verify with Federal Revenue.",
          cnpjError: "Error validating document. Please try again.",
          phoneInvalid: "Invalid WhatsApp number",
          phoneRequired: "WhatsApp is required",
          planRequired: "Please select a plan",
          paymentRequired: "Please select a payment method",
          consentRequired: "You must accept auto-renewal to continue",
          installmentsRequired: "Please select the number of installments",
          passwordRequired: "Password is required",
          passwordMin: "Password must be at least 8 characters",
          passwordMax: "Password is too long",
          passwordUppercase: "Password must contain at least 1 uppercase letter",
          passwordNumber: "Password must contain at least 1 number",
          passwordSpecialChar: "Password must contain at least 1 special character",
          passwordMatch: "Passwords do not match",
          confirmPasswordRequired: "Please confirm your password",
          nameMin: "Name is too short",
          nameMax: "Name is too long",
          nameRequired: "Name is required",
          companyNameMin: "Organization name is too short",
          companyNameMax: "Organization name is too long",
          companyNameRequired: "Organization name is required",
          documentRequired: "CPF or CNPJ is required",
          emailInvalid: "Invalid email",
          emailRequired: "Email is required",
        },
      },
      subscription: {
        form: {
          installments: "Installments",
          installmentsHelper: "Split the total into up to {{max}} installments on your credit card.",
          installmentsOption: "{{count}}x of R$ {{value}}",
          installmentsOptionSingle: "Pay in full — R$ {{value}}",
        },
        warnings: {
          pickInstallments: "Please select the number of installments.",
        },
        cancel: {
          button: "Cancel subscription",
          title: "Cancel subscription",
          body: "You will keep access to the system until {{date}}. After that date your account will become inactive and no further charges will be made automatically. You can reactivate any time by choosing a new plan.",
          confirm: "Are you sure you want to cancel?",
          back: "Back",
          confirmButton: "Confirm cancellation",
          success: "Subscription cancelled.",
          successWithDate: "Subscription cancelled. You have access until {{date}}.",
        },
        reactivate: {
          button: "Reactivate subscription",
          title: "Reactivate subscription",
          body: "Your subscription will be reactivated. The next renewal will be charged automatically on {{date}}.",
          back: "Back",
          confirmButton: "Confirm reactivation",
          success: "Subscription reactivated.",
          successWithDate: "Subscription reactivated. The next renewal will be on {{date}}.",
        },
        pixBoletoNote: "PIX and Boleto plans are not auto-charged. To stop renewing, just don't pay the next invoice.",
      },
      login: {
        title: "Login",
        welcome: "Welcome back",
        loginInstruction: "Enter your credentials to access your account",
        form: {
          email: "Email",
          password: "Password",
          button: "Access",
        },
        buttons: {
          submit: "Enter",
          register: "Don't have an account? Register!",
          forgotPassword: "Forgot your password?",
        },
        forgotPassword: {
          title: "Forgot your password?",
          subtitle: "Enter your email and we'll send you a verification code.",
          sendCode: "Send Code",
          backToLogin: "Back to login",
        },
        resetPassword: {
          title: "Reset your password",
          subtitle: "Enter the code sent to your email and your new password.",
          codeLabel: "Verification Code",
          newPasswordLabel: "New Password",
          submitButton: "Reset Password",
        },
        mfa: {
          newPasswordRequired: "Set a new password to continue",
          newPassword: "New password",
          confirmPassword: "Confirm",
          setupTitle: "Set up two-factor authentication",
          setupDescription: "Scan the QR code with your authenticator app (Google Authenticator, Authy, etc.)",
          verificationCode: "Verification code",
          verify: "Verify",
          verifyTitle: "Two-factor authentication",
          verifyDescription: "Enter the code from your authenticator app",
          backToLogin: "Back to login",
        },
        mfaRecovery: {
          trigger: "Lost access to your authenticator?",
          requestTitle: "MFA recovery",
          requestSubtitle: "Lost access to your authenticator app?",
          requestInfo: "A 6-digit code will be sent to",
          sendCode: "Send Code",
          cancel: "Cancel",
          verifyTitle: "Enter the recovery code",
          verifySubtitle: "We sent a 6-digit code to your email.",
          codeLabel: "Recovery code",
          verifyButton: "Verify Code",
          back: "Back",
          requestNewCode: "Request a new code",
          expiresIn: "Code expires in",
          expired: "Code expired. Request a new code.",
          successTitle: "MFA reset successfully!",
          successBody: "Two-factor authentication has been reset. You can log in again and set up a new authenticator.",
          successInfo: "Close this window and log in again — you will need to set up a new authenticator app.",
          redirecting: "Redirecting in {{count}} seconds...",
          closeNow: "Close now",
          toasts: {
            codeSent: "Recovery code sent to your email!",
            resetSuccess: "MFA reset successfully!",
          },
        },
        toasts: {
          passwordResetSuccess: "Password reset successfully!",
          resetCodeSent: "Verification code sent to your email!",
        },
      },
      companies: {
        title: "Register Company",
        form: {
          name: "Company Name",
          plan: "Plan",
          token: "Token",
          submit: "Register",
          success: "Company successfully created!",
        },
      },
      auth: {
        toasts: {
          success: "Login successful!",
          expired: "Your plan has expired. Choose a plan to continue.",
        },
        dueDate: {
          expiration: "Your subscription expires in",
          days: "days!",
          day: "day!",
          expirationToday: "Your subscription expires today!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filters",
        filter: "FILTER ",
        tabs: {
          indicators: "Indicators",
          assessments: "NPS",
          attendants: "Agents",
        },
        charts: {
          perDay: {
            title: "Attendances today: ",
          },
        },
        cards: {
          inAttendance: "In Attendance",
          waiting: "Waiting",
          activeAttendants: "Active Agents",
          finalized: "Finalized",
          newContacts: "New Contacts",
          totalReceivedMessages: "Received Messages",
          totalSentMessages: "Sent Messages",
          averageServiceTime: "Average Service Time",
          averageWaitingTime: "Average Waiting Time",
          status: "Status (Current)",
          activeTickets: "Active Tickets",
          passiveTickets: "Passive Tickets",
          groups: "Groups",
        },
        users: {
          name: "Name",
          numberAppointments: "Number of Attendances",
          statusNow: "Current Status",
          totalCallsUser: "Total Attendances per User",
          totalAttendances: "Total Attendances",
        },
        date: {
          initialDate: "Start Date",
          finalDate: "End Date",
        },
        licence: {
          available: "Available until",
        },
        assessments: {
          totalCalls: "Total Attendances",
          callsWaitRating: "Attendances Waiting for Rating",
          callsWithoutRating: "Attendances Without Rating",
          ratedCalls: "Rated Attendances",
          evaluationIndex: "Evaluation Index",
          score: "Score",
          prosecutors: "Promoters",
          neutral: "Neutral",
          detractors: "Detractors",
        },
      },
      reports: {
        title: "Attendance Reports",
        startDate: "Start date ",
        endDate: "End date",
        table: {
          id: "Ticket",
          user: "User",
          dateOpen: "Opening Date",
          dateClose: "Closing Date",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Connection",
          queue: "Queue",
          actions: "Actions",
          lastMessage: "Last Message",
          contact: "Customer",
          supportTime: "Attendance Time",
        },
        buttons: {
          filter: "Apply Filter",
          onlyRated: "Only Rated",
        },
        searchPlaceholder: "Search...",
      },
      todo: {
        newTask: "New Task",
        add: "Add",
        task: "Tasks",
      },
      contactImportWpModal: {
        title: "Export Contacts",
        buttons: {
          downloadModel: "Download Template",
          closed: "Close",
          import: "Import Contacts",
        },
      },
      connections: {
        title: "Connections",
        waitConnection: "Please wait... Your connections will be restarted!",
        newConnection: "New Connection",
        restartConnections: "Restart Connections",
        callSupport: "Call Support",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers: " Connect your service channels to receive messages and start conversations with your customers.",
        client: "Client",
        connectedConnections: "Connected connections",
        disconnectedConnections: "Disconnected connections",
        totalConnections: "Total connections",
        total: "Total",
        connections: " Connections:",
        toasts: {
          deleted: "Connection successfully deleted!",
          closedimported: "Closing imported tickets, please wait a few moments.",
        },
        confirmationModal: {
          closedImportedTitle: "Close imported tickets",
          closedImportedMessage: "If you confirm, all imported tickets will be closed.",
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone.",
          disconnectTitle: "Disconnect",
          disconnectMessage: "Are you sure? You will need to scan the QR Code again.",
        },
        buttons: {
          add: "Add Connection",
          disconnect: "Disconnect",
          tryAgain: "Try Again",
          qrcode: "QR CODE",
          newQr: "New QR CODE",
          closedImported: "Close all imported tickets",
          preparing: "Preparing messages for import",
          importing: "Importing WhatsApp Messages",
          processed: "Processed",
          in: "of",
          connecting: "Connecting",
        },
        bulkDelete: {
          noneSelected: "Select at least one connection to delete.",
          button: "Delete Selected ({{count}})",
          dialogTitle: "Delete {{count}} selected connection(s)?",
          dialogMessage: "This action cannot be undone.",
          toastSuccess: "{{count}} connection(s) deleted successfully.",
          toastError: "{{count}} connection(s) could not be deleted.",
        },
        typography: {
          processed: "Processed",
          in: "of",
          date: "Message Date",
        },
        toolTips: {
          disconnected: {
            title: "Failed to start WhatsApp session",
            content: "Make sure your phone is connected to the internet and try again, or request a new QR Code.",
          },
          qrcode: {
            title: "Waiting for QR Code scan",
            content: "Click the 'QR CODE' button and scan the QR Code with your phone to start the session.",
          },
          connected: {
            title: "Connection established!",
          },
          timeout: {
            title: "Connection with the phone was lost",
            content: "Make sure your phone is connected to the internet and WhatsApp is open, or click 'Disconnect' to get a new QR Code.",
          },
        },
        table: {
          name: "Name",
          status: "Status",
          lastUpdate: "Last Update",
          default: "Default",
          actions: "Actions",
          session: "Session",
          number: "WhatsApp Number",
          color: "Color",
        },
        facebook: {
          success: "Facebook page connected successfully!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Existing Attendance",
        },
        form: {
          message: "This contact is already being attended to:",
          user: "Agent",
          queue: "Queue",
          messageWait: "This contact is already waiting for service. Check the Waiting tab!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket created.",
          chatBot: "ChatBot started.",
          queue: " - Queue assigned.",
          open: " started the service.",
          access: "accessed the ticket.",
          transfered: "transferred the ticket.",
          receivedTransfer: "received the transferred ticket.",
          pending: "returned to the queue.",
          closed: "closed the ticket.",
          reopen: "reopened the ticket.",
          redirect: "- redirected",
          clientClosed: "Client closed the ticket.",
        },
      },
      whatsappModal: {
        title: {
          add: "Add Connection",
          edit: "Edit Connection",
        },
        tabs: {
          general: "General",
          messages: "Messages",
          assessments: "NPS",
          integrations: "Integrations",
          schedules: "Business Hours",
        },
        form: {
          importOldMessagesEnable: "Import messages from device",
          importOldMessages: "Start date of import",
          importRecentMessages: "End date of import",
          importOldMessagesGroups: "Import group messages",
          closedTicketsPostImported: "Close tickets after import",
          name: "Name",
          queueRedirection: "Queue Redirection",
          queueRedirectionDesc: "Select a queue for contacts without an assigned queue",
          default: "Default",
          group: "Allow groups",
          timeSendQueue: "Time in minutes to redirect to queue",
          msgSendQueue: "Message when redirecting to queue (optional)",
          importAlert: "WARNING: Saving will terminate your connection. You will need to scan the QR Code again to import messages.",
          groupAsTicket: "Treat groups as ticket",
          timeCreateNewTicket: "Create a new ticket after X minutes",
          maxUseBotQueues: "Send bot X times",
          maxUseInactiveTime: "Send inactivity flow X times",
          timeUseBotQueues: "Send bot in X minutes",
          timeToReturnQueue: "Time to return to queue in minutes",
          timeAwaitActiveFlow: "Time to wait for active flow",
          expiresTicket: "Close open chats after X minutes",
          expiresTicketNPS: "Close chats awaiting evaluation after X minutes",
          maxUseBotQueuesNPS: "Max times evaluation is sent",
          closeLastMessageOptions1: "From agent/client",
          closeLastMessageOptions2: "From agent only",
          outOfHoursMessage: "Out-of-hours message",
          greetingMessage: "Greeting message",
          complationMessage: "Completion message",
          lgpdLinkPrivacy: "Privacy policy link",
          lgpdMessage: "LGPD greeting message",
          lgpdDeletedMessages: "Obfuscate messages deleted by contact",
          lgpdSendMessage: "Always request contact confirmation",
          ratingMessage: "Evaluation message - Scale must be from 0 to 10",
          token: "Token for external integration",
          sendIdQueue: "Queue",
          inactiveMessage: "Inactivity warning message",
          timeInactiveMessage: "Time in minutes to send inactivity warning",
          flowInactiveTime: "Time in minutes to send inactivity flow",
          whenExpiresTicket: "Close chats when the last message is",
          expiresInactiveMessage: "Inactivity closure message",
          collectiveVacationSection: "Collective Vacation",
          collectiveVacationEnd: "End date",
          collectiveVacationStart: "Start date",
          collectiveVacationMessage: "Collective vacation message",
          queueIdImportMessages: "Queue for message import",
          isOficial: "Official",
          phone_number_id: "Phone Number ID",
          waba_id: "WABA ID",
          send_token: "Sending token",
          business_id: "Business ID",
          phone_number: "Phone number",
          triggerIntegrationOnClose: "Trigger Integration on Ticket Close",
          enableIntegration: "Habilited Integration",
          queuesDisabledByIntegration: "Disabled because this connection already uses FlowLive Integration (Entry). Remove the integration to select queues.",
          integrationDisabledByQueues: "Disabled because this connection already has queues selected. Remove the queues to use FlowLive Integration (Entry).",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        menuItem: {
          enabled: "Enabled",
          disabled: "Disabled",
          minutes: "minutes",
        },
        success: "Connection saved successfully.",
        errorSendQueue: "You set a redirection time but no queue was selected. Both fields are required.",
        errorExpiresNPS: "A timeout must be set for NPS evaluation.",
        errorRatingMessage: "An evaluation message must be provided for NPS.",
      },
      qrCode: {
        message: "Scan the QR Code to start the session",
        waiting: "Waiting for QR Code...",
      },
      contacts: {
        title: "Contacts",
        toasts: {
          deleted: "Contact successfully deleted!",
        },
        searchPlaceholder: "Search...",
        conversationFlows: " Conversation Flows",
        addFlow: "Add Flow",
        editFlow: "Edit Flow ",
        confirmationModal: {
          deleteTitle: "Delete",
          importTitlte: "Import Contacts",
          exportContact: "Export Contacts",
          deleteMessage: "Are you sure you want to delete this contact? All related attendances will be lost.",
          blockContact: "Are you sure you want to block this contact?",
          unblockContact: "Are you sure you want to unblock this contact?",
          importMessage: "Do you want to import all contacts from the phone?",
          importChat: "Import Chats",
          wantImport: "Do you want to import all chats from the phone?",
        },
        buttons: {
          import: "Import Contacts",
          add: "Add Contact",
          export: "Export Contact",
        },
        loading: "Loading...",
        loadMore: "Load More",
        table: {
          name: "Name",
          whatsapp: "Connection",
          country: "Country",
          email: "Email",
          actions: "Actions",
          lastMessage: "Last Message",
          wallet: "Wallet",
        },
        menu: {
          importYourPhone: "Import from default device",
          importToExcel: "Import/Export from Excel",
          importexport: "IMPORT / EXPORT ",
        },
        duplicatesToast: {
          summary: "{{imported}} imported, {{duplicates}} duplicates",
          download: "Download duplicates",
        },
        importReport: {
          summary: "{{imported}} imported, {{duplicates}} duplicates, {{rejected}} not imported",
          download: "Download report",
          missingFields: "Missing required fields: {{fields}}",
        },
        filters: {
          createdAt: "Created At",
          to: "To",
        },
      },
      forwardMessage: {
        text: "Forwarded",
      },
      forwardMessageModal: {
        title: "Forward Message",
        buttons: {
          ok: "Forward",
        },
      },
      contactModal: {
        validation: {
          birthDateMin: "Invalid birth date",
          birthDateFuture: "Birth date cannot be in the future",
        },
        title: {
          add: "Add Contact",
          edit: "Edit Contact",
        },
        form: {
          mainInfo: "Contact Data",
          extraInfo: "Additional Information",
          name: "Name",
          number: "WhatsApp Number",
          email: "Email",
          extraName: "Field Name",
          extraValue: "Value",
          chatBotContact: "Disable Chatbot",
          termsLGDP: "LGPD Terms accepted on:",
          whatsapp: "Origin Connection:",
          attendant: "Attendant",
          customer_portfolio: "Customer Portfolio",
          queue: "Queue",
          assignWallet: "Customer Wallet",
        },
        buttons: {
          addExtraInfo: "Add Information",
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Contact saved successfully.",
        walletLinked: "Contact linked to your wallet successfully!",
        walletError: "User has no associated queues",
        saveFirst: "Contact must be saved first",
      },
      wallets: {
        title: "Contact Wallets",
        searchPlaceholder: "Search contacts...",
        filterByUser: "Filter by User",
        allUsers: "All users",
        contact: "Contact",
        user: "User",
        queue: "Queue",
        phone: "Phone",
        email: "Email",
        actions: "Actions",
        editWallet: "Edit Wallet",
        selectUser: "Select User",
        selectQueue: "Select Queue",
        selectUserAndQueue: "Select a user and queue",
        cancel: "Cancel",
        save: "Save",
        confirmDeleteTitle: "Confirm Deletion",
        confirmDeleteMessage: "Are you sure you want to remove this contact from the wallet?",
        deleteSuccess: "Contact removed from wallet successfully!",
        updateSuccess: "Wallet updated successfully!",
        wallet: "Wallet",
      },
      queueModal: {
        title: {
          queueData: "Queue Data",
          text: "Business Hours",
          add: "Add Queue",
          edit: "Edit Queue",
          confirmationDelete: "Are you sure? All integration options will be deleted.",
        },
        form: {
          name: "Name",
          color: "Color",
          orderQueue: "Queue Order (Bot)",
          rotate: "Rotation",
          timeRotate: "Rotation Time",
          typeRandomMode: "Rotation Type",
          greetingMessage: "Greeting Message",
          complationMessage: "Completion Message",
          outOfHoursMessage: "Out-of-Hours Message",
          token: "Token",
          integrationId: "FlowLive Integration (Inbound)",
          integrationTypeId: "FlowLive Integration (On Close)",
          fileListId: "File List",
          closeTicket: "Close Ticket",
          queueType: "Menu Type",
          message: "Return Message",
          queue: "Transfer Queue",
          integration: "Integration",
          file: "File List",
          randomizeImmediate: "Randomize Automatically (Immediate)",
          selectRotationType: "Select rotation type",
        },
        toasts: {
          invalidForm: "Could not save. Check the required fields and the chatbot options.",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        bot: {
          title: "Options",
          toolTipTitle: "Add options to build a chatbot",
          toolTip: "If there is only one option, it will be automatically chosen, and the bot will respond with the message and proceed",
          selectOption: "Select an Option",
          text: "Text",
          attendent: "Agent",
          queue: "Queue",
          integration: "Integration",
          file: "File",
          toolTipMessageTitle: "Message is required to proceed to the next level",
          toolTipMessageContent: "Message is required to proceed to the next level",
          selectUser: "Select a User",
          selectQueue: "Select a Queue",
          selectIntegration: "Select an Integration",
          addOptions: "Add Options",
        },
        serviceHours: {
          dayWeek: "Day of the Week",
          startTimeA: "Start Time - Shift A",
          endTimeA: "End Time - Shift A",
          startTimeB: "Start Time - Shift B",
          endTimeB: "End Time - Shift B",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Add Project",
          edit: "Edit Project",
        },
        form: {
          id: "ID",
          type: "Type",
          name: "Name",
          projectName: "Project Name",
          language: "Language",
          jsonContent: "JSON Content",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Expiration time in minutes",
          typebotKeywordFinish: "Keyword to finish the ticket",
          typebotKeywordRestart: "Keyword to restart the flow",
          typebotRestartMessage: "Message when restarting the conversation",
          typebotUnknownMessage: "Invalid option message",
          typebotDelayMessage: "Delay (ms) between messages",
          flow: "FlowLive flow",
          flowNone: "No flow linked",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          test: "Test Bot",
        },
        messages: {
          testSuccess: "Integration tested successfully!",
          addSuccess: "Integration added successfully.",
          editSuccess: "Integration edited successfully.",
        },
      },
      userModal: {
        warning: {
          updateImage: "Image will be updated on save",
        },
        password: {
          chars: "8+ characters",
          uppercase: "1 uppercase",
          number: "1 number",
          special: "1 special",
        },
        validation: {
          birthDateMin: "Invalid birth date",
          birthDateFuture: "Birth date cannot be in the future",
        },
        title: {
          add: "Add User",
          edit: "Edit User",
          updateImage: "Update Image",
          removeImage: "Delete Image",
        },
        form: {
          name: "Name",
          email: "Email",
          password: "Password",
          farewellMessage: "Farewell Message",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          whatsapp: "Default Connection",
          allTicketEnable: "Enabled",
          allTicketDisable: "Disabled",
          allTicket: "View Tickets Without Queue",
          allowGroup: "Allow Groups",
          defaultMenuOpen: "Open",
          defaultMenuClosed: "Closed",
          defaultMenu: "Default Menu",
          defaultTheme: "Default Theme",
          defaultThemeDark: "Dark",
          defaultThemeLight: "Light",
          allHistoric: "View Conversations from Other Queues",
          allHistoricEnabled: "Enabled",
          allHistoricDisabled: "Disabled",
          allUserChat: "View Other Users' Conversations",
          userClosePendingTicket: "Allow Closing Pending Tickets",
          showDashboard: "View Dashboard",
          allowRealTime: "View Real-Time Panel",
          allowConnections: "Allow Actions on Connections",
          showContacts: "View Contacts",
          showCampaign: "View Campaigns",
          changeEmail: "Change Email",
          newEmail: "New Email",
          changePassword: "Change Password",
          newPassword: "New Password",
          confirmPassword: "Confirm Password",
          allowSeeMessagesInPendingTickets: "Allow viewing pending tickets",
          showFlow: "View Flows",
        },
        tabs: {
          general: "General",
          permissions: "Permissions",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addImage: "Add Image",
          editImage: "Edit Image",
          saveEmail: "Save Email",
          savePassword: "Save Password",
        },
        success: "User saved successfully.",
        successEmail: "Email updated successfully.",
        successPassword: "Password updated successfully.",
        successProfile: "Profile updated successfully.",
        errorPasswordMismatch: "Passwords do not match.",
      },
      companyModal: {
        title: {
          add: "Add Company",
          edit: "Edit Company",
        },
        form: {
          name: "Name",
          email: "Email",
          passwordDefault: "Password",
          numberAttendants: "Users",
          numberConections: "Connections",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Company saved successfully.",
      },
      scheduleModal: {
        title: {
          add: "New Schedule",
          edit: "Edit Schedule",
          message: "Message",
        },
        form: {
          body: "Message",
          contact: "Contact",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          assinar: "Send Signature",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
          addSchedule: "Add Schedule",
        },
        success: "Schedule saved successfully.",
        confirmationModal: {
          deleteMessage: "Are you sure you want to delete this schedule?",
          deleteTitle: "Delete Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully!",
        },
      },
      tagModal: {
        title: {
          add: "New Tag",
          edit: "Edit Tag",
          addKanban: "New Lane",
          editKanban: "Edit Lane",
          backToKanban: "BACK TO KANBAN",
        },
        form: {
          name: "Name",
          color: "Color",
          timeLane: "Time in minutes to redirect to lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Lane Greeting Message",
          mediaFiles: "Media",
          rollbackLaneId: "Return to Lane after resuming attendance",
        },
        buttons: {
          okAdd: "Add",
          okEdit: "Save",
          cancel: "Cancel",
        },
        success: "Tag saved successfully.",
        successKanban: "Lane saved successfully.",
      },
      fileModal: {
        title: {
          add: "Add File List",
          edit: "Edit File List",
        },
        buttons: {
          okAdd: "Save",
          okEdit: "Edit",
          cancel: "Cancel",
          fileOptions: "Add File",
        },
        form: {
          name: "File List Name",
          message: "List Details",
          fileOptions: "File List",
          extraName: "Message to send with file",
          extraValue: "Option Value",
        },
        success: "File list saved successfully!",
      },
      chat: {
        noTicketMessage: "Select a ticket to start chatting.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "⬇️ DRAG AND DROP FILES BELOW ⬇️",
          titleFileList: "File List",
        },
      },
      chatInternal: {
        new: "New group",
        modal: {
          conversation: "Conversation",
          title: "Title",
          filterUsers: "Filter by Users",
          cancel: "Close",
          save: "Save",
        },
        modalDelete: {
          title: "Delete Conversation",
          message: "This action cannot be undone, confirm?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "DO YOU WANT TO CLOSE ALL TICKETS?",
        yes: "YES",
        not: "NO",
        buttons: {
          newTicket: "New",
          resolveAll: "Resolve All",
          close: "Close",
          new: "New",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Queues",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Close all tickets?",
          closedAll: "Close All",
          newTicket: "New Ticket",
          yes: "YES",
          no: "NO",
          open: "Open",
          resolverd: "Resolved",
          bulkTransfer: "Bulk Transfer",
          selectAll: "Select all",
          deselectAll: "Deselect all",
        },
        toasts: {
          deleted: "The attendance you were handling has been deleted.",
        },
        notification: {
          message: "Message from",
        },
        tabs: {
          open: {
            title: "Open",
          },
          closed: {
            title: "Resolved",
          },
          search: {
            title: "Search",
          },
        },
        search: {
          placeholder: "Search attendance and messages",
          filterConections: "Filter by Connection",
          filterConectionsOptions: {
            open: "Open",
            closed: "Closed",
            pending: "Pending",
          },
          filterUsers: "Filter by Users",
          selectAllUsers: "Select all",
          clearAllUsers: "Clear selection",
          filterContacts: "Filter by Contacts",
          ticketsPerPage: "Tickets per page",
        },
        buttons: {
          showAll: "All",
          returnQueue: "Return to Queue",
          scredule: "Schedule",
          deleteTicket: "Delete Ticket",
        },
        closedTicket: {
          closedMessage: "Close Ticket With Farewell Message",
          closedNotMessage: "Close Ticket Without Farewell Message",
        },
        filters: {
          keyWord: "Keyword",
          to: "To",
          updatedAt: "Updated At",
        },
        messageHidden: "Message hidden",
      },
      transferTicketModal: {
        title: "Transfer Ticket",
        fieldLabel: "Type to search for users",
        fieldQueueLabel: "Transfer to Queue",
        fieldQueuePlaceholder: "Select a queue",
        fieldWhatsapp: "Select a WhatsApp",
        noOptions: "No users found with that name",
        msgTransfer: "Notes - internal message, will not be sent to the client",
        buttons: {
          ok: "Transfer",
          cancel: "Cancel",
        },
      },
      bulkTransferTicketModal: {
        title: "Transfer {{count}} Ticket(s)",
        button: "Transfer ({{count}})",
        fieldLabelRequired: "Select an attendant (required)",
        toastSuccessSync: "{{count}} ticket(s) successfully transferred.",
        toastCompleted: "{{transferred}} of {{total}} ticket(s) successfully transferred.",
        toastError: "Error transferring the selected tickets.",
        progressDialogTitle: "Transferring Tickets",
        progressText: "{{current}} of {{total}} tickets transferred",
      },
      ticketsList: {
        called: "Call",
        today: "Today",
        missedCall: "Missed voice/video call at",
        pendingHeader: "Waiting",
        assignedHeader: "In Attendance",
        groupingHeader: "Groups",
        noTicketsTitle: "Nothing here!",
        noTicketsMessage: "No attendances found with this status or search term",
        noQueue: "No Queue",
        buttons: {
          accept: "Accept",
          cancel: "Cancel",
          start: "Start",
          closed: "Close",
          reopen: "Reopen",
          transfer: "Transfer",
          ignore: "Ignore",
          exportAsPDF: "Export to PDF",
          kanbanActions: "Kanban Options",
        },
        acceptModal: {
          title: "Accept Chat",
          queue: "Select Sector",
          noQueuesWarning: "You are not assigned to any sector. Ask an administrator to add you to a sector before accepting this conversation.",
        },
      },
      newTicketModal: {
        title: "Create Ticket",
        fieldLabel: "Type to search for a contact",
        add: "Add",
        buttons: {
          ok: "Save",
          cancel: "Cancel",
        },
      },
      SendContactModal: {
        title: "Send Contact",
        fieldLabel: "Type to search for contact",
        add: "Add",
        buttons: {
          ok: "Send",
          cancel: "Cancel",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Connections",
          chatsTempoReal: "Real-Time Panel",
          tickets: "Attendances",
          quickMessages: "Quick Replies",
          contacts: "Contacts",
          wallets: "Wallets",
          queues: "Queues",
          tenant: "Tenant",
          tags: "Tags",
          administration: "Administration",
          companies: "Companies",
          users: "Users",
          birthdaySettings: "Birthday Settings",
          settings: "Settings",
          files: "File Lists",
          helps: "Help Center",
          messagesAPI: "API",
          schedules: "Schedules",
          campaigns: "Campaigns",
          annoucements: "Announcements",
          chats: "Internal Chat",
          subscription: "Subscription",
          financeiro: "Financial",
          queueIntegration: "Integrations",
          version: "Version",
          kanban: "CRM",
          allConnections: "Manage Connections",
          reports: "Reports",
          flowbuilder: "FlowLive",
          todoList: "To-Do List",
          management: "Management",
          callHistorical: "Call History",
        },
        appBar: {
          user: {
            profile: "Profile",
            logout: "Logout",
            message: "Hello",
            messageEnd: "welcome to",
            active: "Active until",
            goodMorning: "Hi,",
            myName: "my name is",
            continuity: "and I will continue your service.",
            virtualAssistant: "Virtual Assistant",
            token: "Invalid token, please contact the platform administrator.",
          },
          message: {
            location: "Location",
            contact: "Contact",
          },
          notRegister: "No records found",
          refresh: "Refresh",
        },
      },
      languages: {
        undefined: "Language",
        "pt-BR": "Portuguese",
        es: "Spanish",
        en: "English",
        tr: "Turkish",
      },
      messagesAPI: {
        title: "API",
        toSend: "TO SEND",
        textMessage: {
          number: "Number",
          body: "Message",
          token: "Registered Token",
          userId: "User/Agent ID",
          queueId: "Queue ID",
        },
        mediaMessage: {
          number: "Number",
          body: "File Name",
          media: "File",
          token: "Registered Token",
        },
        API: {
          title: "Message Sending Documentation",
          methods: {
            title: "Sending Methods",
            messagesText: "Text Messages",
            messagesMidia: "Media Messages",
          },
          instructions: {
            title: "Instructions",
            comments: "Important Notes",
            comments1: "Before sending messages, it is necessary to register the token linked to the connection that will send the messages. <br />To register, access the 'Connections' menu, click the edit button on the connection, and insert the token in the appropriate field.",
            comments2: "The sending number must not have a mask or special characters and must be composed of:",
            codeCountry: "Country Code",
            code: "Area Code (DDD)",
            number: "Phone Number",
          },
          text: {
            title: "1. Text Messages",
            instructions: "Below is the list of required information to send text messages:",
          },
          media: {
            title: "2. Media Messages",
            instructions: "Below is the list of required information to send media messages:",
          },
        },
      },
      notifications: {
        noTickets: "No notifications.",
        messageHidden: "Message hidden",
        aiTransfer: {
          title: "New contact in queue {{queue}}",
          titleNoQueue: "Contact transferred by Agente FlowLive (no queue)",
        },
        ticketTransfer: {
          title: "Ticket transferred to you",
        },
        unansweredReminder: {
          title: "Customer waiting for a reply",
        },
      },
      quickMessages: {
        title: "Quick Replies",
        searchPlaceholder: "Search...",
        noAttachment: "No attachment",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action is irreversible! Do you want to proceed?",
        },
        buttons: {
          add: "Add",
          attach: "Attach File",
          cancel: "Cancel",
          edit: "Edit",
        },
        toasts: {
          success: "Shortcut added successfully!",
          deleted: "Shortcut removed successfully!",
        },
        dialog: {
          title: "Quick Message",
          shortcode: "Shortcut",
          message: "Response",
          save: "Save",
          cancel: "Cancel",
          general: "General",
          geral: "Allow Editing",
          add: "Add",
          edit: "Edit",
          visao: "Allow Viewing",
          category: "Category",
          language: "Language",
          metaID: "Meta ID",
          status: "Status",
        },
        table: {
          shortcode: "Shortcut",
          message: "Message",
          actions: "Actions",
          mediaName: "File Name",
          status: "Status",
        },
        global: "Global",
        hasMedia: "With media",
        noQuickMessages: "No quick messages available",
        noResultsFound: "No quick messages found for your search",
        selectMessage: "Select Quick Message",
      },
      contactLists: {
        title: "Contact Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New List",
        },
        dialog: {
          name: "Name",
          company: "Company",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      contactListItems: {
        title: "Contacts",
        searchPlaceholder: "Search",
        buttons: {
          add: "New",
          lists: "Lists",
          import: "Import",
        },
        duplicatesToast: {
          summary: "{{imported}} imported, {{duplicates}} duplicates",
          download: "Download duplicates",
        },
        dialog: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          okEdit: "Edit",
          okAdd: "Add",
          add: "Add",
          edit: "Edit",
          cancel: "Cancel",
        },
        table: {
          name: "Name",
          number: "Number",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Actions",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
          importMessage: "Do you want to import the contacts from this spreadsheet?",
          importTitlte: "Import",
        },
        toasts: {
          deleted: "Record deleted successfully.",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Board",
          tags: "Lanes",
        },
      },
      campaigns: {
        title: "Campaigns",
        searchPlaceholder: "Search",
        subMenus: {
          list: "Listing",
          listContacts: "Contact List",
          settings: "Settings",
        },
        settings: {
          randomInterval: "Random Sending Interval",
          noBreak: "No Interval",
          intervalGapAfter: "Longer interval after",
          undefined: "Undefined",
          messages: "messages",
          laggerTriggerRange: "Larger Sending Interval",
          addVar: "Add Variable",
          save: "Save",
          close: "Close",
          add: "Add",
          shortcut: "Shortcut",
          content: "Content",
        },
        buttons: {
          add: "New Campaign",
          contactLists: "Contact Lists",
        },
        table: {
          name: "Name",
          whatsapp: "Connection",
          contactList: "Contact List",
          option: "None",
          disabled: "Disabled",
          enabled: "Enabled",
          status: "Status",
          scheduledAt: "Scheduled",
          completedAt: "Completed",
          confirmation: "Confirmation",
          actions: "Actions",
        },
        dialog: {
          new: "New Campaign",
          update: "Edit Campaign",
          readonly: "View Only",
          help: "Use variables like {name}, {number}, {email}, or define custom variables.",
          form: {
            name: "Name",
            message1: "Message 1",
            message2: "Message 2",
            message3: "Message 3",
            message4: "Message 4",
            message5: "Message 5",
            confirmationMessage1: "Confirmation Message 1",
            confirmationMessage2: "Confirmation Message 2",
            confirmationMessage3: "Confirmation Message 3",
            confirmationMessage4: "Confirmation Message 4",
            confirmationMessage5: "Confirmation Message 5",
            messagePlaceholder: "Message content",
            whatsapp: "Connection",
            status: "Status",
            scheduledAt: "Schedule",
            confirmation: "Confirmation",
            contactList: "Contact List",
            tagList: "Tags",
            statusTicket: "Ticket Status",
            openTicketStatus: "Open",
            pendingTicketStatus: "Pending",
            closedTicketStatus: "Closed",
            enabledOpenTicket: "Enabled",
            disabledOpenTicket: "Disabled",
            openTicket: "Open Ticket",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel Sending",
            restart: "Restart Sending",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          cancel: "Campaign canceled.",
          restart: "Campaign restarted.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignReport: {
        title: "Campaign Report",
        inactive: "Inactive",
        scheduled: "Scheduled",
        process: "In Progress",
        cancelled: "Canceled",
        finished: "Completed",
        campaign: "Campaign",
        validContacts: "Valid Contacts",
        confirmationsRequested: "Confirmations Requested",
        confirmations: "Confirmations",
        deliver: "Delivered",
        connection: "Connection",
        contactLists: "Contact List",
        schedule: "Schedule",
        conclusion: "Conclusion",
        backButton: "Back",
        fetchError: "Error fetching report data",
      },
      announcements: {
        title: "Announcements",
        searchPlaceholder: "Search",
        active: "Active",
        inactive: "Inactive",
        buttons: {
          add: "New Announcement",
          contactLists: "Announcement Lists",
        },
        table: {
          priority: "Priority",
          title: "Title",
          text: "Text",
          mediaName: "File",
          status: "Status",
          actions: "Actions",
        },
        dialog: {
          edit: "Edit Announcement",
          add: "New Announcement",
          update: "Edit Announcement",
          readonly: "View Only",
          form: {
            priority: "Priority",
            title: "Title",
            text: "Text",
            mediaPath: "File",
            status: "Status",
            high: "High",
            medium: "Medium",
            low: "Low",
            active: "Active",
            inactive: "Inactive",
          },
          buttons: {
            add: "Add",
            edit: "Update",
            okadd: "Ok",
            cancel: "Cancel",
            close: "Close",
            attach: "Attach File",
          },
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "This action cannot be undone.",
        },
        toasts: {
          success: "Operation completed successfully.",
          deleted: "Record deleted successfully.",
        },
      },
      campaignsConfig: {
        title: "Campaign Settings",
      },
      queues: {
        title: "Queues & Chatbot",
        table: {
          name: "Name",
          color: "Color",
          greeting: "Greeting Message",
          orderQueue: "Queue Order (Bot)",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add Queue",
        },
        toasts: {
          success: "Queue saved successfully.",
          deleted: "Queue deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone! Attendances from this queue will still exist but will no longer be assigned to a queue.",
        },
        bulkDelete: {
          noneSelected: "Select at least one queue to delete.",
          button: "Delete Selected ({{count}})",
          dialogTitle: "Delete {{count}} selected queue(s)?",
          dialogMessage: "This action cannot be undone. Tickets from the deleted queues will still exist but will have no queue assigned.",
          toastSuccess: "{{count}} queue(s) deleted successfully.",
          toastError: "{{count}} queue(s) could not be deleted.",
        },
      },
      queue: {
        queueData: "Queue Data",
      },
      aiKnowledgeFiles: {
        toggleLabel: "Use knowledge base (RAG)",
        hint: "Attach PDFs (up to 5MB each) so the AI can also answer based on their content.",
        uploadButton: "Upload PDF",
        maxSizeLabel: "Max. 5MB",
        saveNodeFirst: "Save the node first to be able to attach files.",
        status: {
          processing: "Processing...",
          ready: "Ready",
          error: "Error",
        },
        errors: {
          mustBePdf: "The file must be a PDF.",
          tooLarge: "The file exceeds the 5MB limit.",
          missingApiKey: "Enter the API Key before attaching files.",
        },
      },
      queueSelect: {
        inputLabel: "Queues",
        inputLabelRO: "Read-Only Queues",
        withoutQueue: "No Queue",
      },
      queueIntegration: {
        title: "Integrations",
        table: {
          id: "ID",
          type: "Type",
          name: "Name",
          flow: "Flow",
          noFlow: "No flow linked",
          projectName: "Project Name",
          language: "Language",
          lastUpdate: "Last Update",
          actions: "Actions",
        },
        buttons: {
          add: "Add Integration",
        },
        searchPlaceholder: "Search...",
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "Are you sure? This action cannot be undone and will be removed from linked queues and connections.",
        },
        toasts: {
          deleted: "Integration deleted successfully!",
        },
        bulkDelete: {
          noneSelected: "Select at least one integration to delete.",
          button: "Delete Selected ({{count}})",
          dialogTitle: "Delete {{count}} selected integration(s)?",
          dialogMessage: "This action cannot be undone.",
          toastSuccess: "{{count}} integration(s) deleted successfully.",
          toastError: "{{count}} integration(s) could not be deleted.",
        },
      },
      users: {
        title: "Users",
        table: {
          status: "Status",
          name: "Name",
          email: "Email",
          profile: "Profile",
          startWork: "Work Start Time",
          endWork: "Work End Time",
          actions: "Actions",
          ID: "ID",
        },
        buttons: {
          add: "Add User",
        },
        toasts: {
          deleted: "User deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "All user data will be lost. Open tickets for this user will be moved to the queue.",
        },
        bulkDelete: {
          noneSelected: "Select at least one user to delete.",
          button: "Delete Selected ({{count}})",
          dialogTitle: "Delete {{count}} selected user(s)?",
          dialogMessage: "This action cannot be undone. Do you really want to delete the selected users?",
          toastSuccess: "{{count}} user(s) deleted successfully.",
          toastError: "{{count}} user(s) could not be deleted.",
        },
      },
      companyUsersDrawer: {
        total: "Total: {{- total}} employees",
        searchPlaceholder: "Search by name or email",
        empty: "This company has no employees yet",
        noMatch: "No employee matches the search",
        noQueue: "No sector",
        retry: "Try again",
        errors: {
          fetch: "Could not load employees",
        },
        profile: {
          admin: "Admin",
          user: "Employee",
        },
        columns: {
          name: "Name",
          email: "Email",
          profile: "Profile",
          queues: "Sectors",
        },
      },
      compaies: {
        title: "Companies",
        bulkDelete: {
          selected: "{{count}} selected",
          clear: "Clear",
          button: "Delete selected",
          dialogTitle: "Delete selected companies",
          dialogIntro: "You are about to delete {{count}} company/companies:",
          dialogWarning: "All data for these companies (employees, tickets, messages, WhatsApp connections, and Asaas subscriptions) will be permanently deleted. This action cannot be undone.",
          confirmWord: "DELETE",
          confirmInputLabel: "Type {{word}} to confirm",
          confirm: "Delete",
          cancel: "Cancel",
          deleting: "Deleting...",
          failuresTitle: "Failures during deletion",
          toastAllOk: "{{count}} company/companies deleted successfully",
          toastPartial: "{{ok}} deleted, {{failed}} failed",
          toastError: "Could not delete the companies",
        },
        table: {
          ID: "ID",
          status: "Active",
          name: "Name",
          email: "Email",
          password: "Password",
          phone: "Phone",
          plan: "Plan",
          active: "Active",
          numberAttendants: "Agents",
          numberConections: "Connections",
          value: "Value",
          namePlan: "Plan Name",
          numberQueues: "Queues",
          useCampaigns: "Campaigns",
          useExternalApi: "REST API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "WhatsApp",
          useInternalChat: "Internal Chat",
          useSchedules: "Scheduling",
          createdAt: "Created At",
          dueDate: "Expiration Date",
          lastLogin: "Last Login",
          folderSize: "Folder size ",
          totalFiles: " Total Files",
          lastUpdate: "Last update",
          actions: "Actions",
          money: "$",
          yes: "Yes",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrence",
          monthly: "Monthly",
          bimonthly: "Bimonthly",
          quarterly: "Quarterly",
          semester: "Semiannual",
          yearly: "Annual",
          clear: "Cancel",
          delete: "Delete",
          user: "User",
          save: "Save",
          generateInvoice: "Generate Invoice",
          employees: "Employees",
          employeesTooltip: "View employees",
        },
        buttons: {
          add: "Add Company",
        },
        toasts: {
          deleted: "Company deleted successfully.",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteMessage: "All company data will be lost. Open tickets for users in this company will be moved to the queue.",
        },
      },
      plans: {
        form: {
          name: "Name",
          users: "Users",
          connections: "Connections",
          campaigns: "Campaigns",
          schedules: "Schedules",
          enabled: "Enabled",
          disabled: "Disabled",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
          yes: "Yes",
          no: "No",
          money: "$",
          public: "Public",
          trial: "Trial",
          trialDays: "Trial Days",
        },
      },
      helps: {
        title: "Help Center",
        settings: {
          codeVideo: "Video Code",
          description: "Description",
          clear: "Cancel",
          delete: "Delete",
          save: "Save",
        },
      },
      schedules: {
        title: "Schedules",
        date: "Date",
        time: "Time",
        event: "Event",
        allDay: "All Day",
        week: "Week",
        work_week: "Work Week",
        day: "Day",
        month: "Month",
        year: "Year",
        stats: {
          total: "Total",
          sent: "Sent",
          errors: "Errors",
          pending: "Pending",
        },
        previous: "Previous",
        next: "Next",
        yesterday: "Yesterday",
        tomorrow: "Tomorrow",
        today: "Today",
        agenda: "Agenda",
        noEventsInRange: "No events in this range.",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Schedule?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          contact: "Contact",
          body: "Message",
          sendAt: "Scheduled Date",
          sentAt: "Sent Date",
          status: "Status",
          actions: "Actions",
        },
        buttons: {
          add: "New Schedule",
        },
        toasts: {
          deleted: "Schedule deleted successfully.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ ADD COLUMNS",
        search: "SEARCH",
        seeTicket: "SEE TICKET",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Tag?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          id: "ID",
          name: "Name",
          kanban: "Kanban",
          color: "Color",
          tickets: "Tag Records",
          contacts: "Contacts",
          actions: "Actions",
        },
        buttons: {
          add: "New Tag",
        },
        toasts: {
          deleted: "Tag deleted successfully.",
        },
      },
      tagsKanban: {
        stage: "Kanban Stage",
        title: "Lanes",
        laneDefault: "Open",
        backToKanban: "BACK TO KANBAN",
        confirmationModal: {
          deleteTitle: "Are you sure you want to delete this Lane?",
          deleteMessage: "This action cannot be undone.",
        },
        table: {
          name: "Name",
          color: "Color",
          tickets: "Tickets",
          actions: "Actions",
        },
        buttons: {
          add: "New Lane",
        },
        toasts: {
          deleted: "Lane deleted successfully.",
        },
      },
      files: {
        title: "File Lists",
        table: {
          name: "Name",
          contacts: "Contacts",
          actions: "Action",
        },
        toasts: {
          deleted: "File list deleted successfully!",
          deletedAll: "All file lists were deleted successfully!",
        },
        buttons: {
          add: "Add",
          deleteAll: "Delete All",
        },
        confirmationModal: {
          deleteTitle: "Delete",
          deleteAllTitle: "Delete All",
          deleteMessage: "Are you sure you want to delete this list?",
          deleteAllMessage: "Are you sure you want to delete all lists?",
        },
      },
      settings: {
        success: "Settings saved successfully.",
        title: "Settings",
        tabs: {
          options: "Options",
          plans: "Plans",
          helps: "Help",
          companies: "Companies",
        },
        settings: {
          userCreation: {
            name: "User Creation",
            options: {
              enabled: "Enabled",
              disabled: "Disabled",
            },
          },
          tabs: {
            options: "Options",
            schedules: "Schedules",
            plans: "Plans",
            help: "Help",
          },
          options: {
            disabled: "Disabled",
            enabled: "Enabled",
            updating: "Updating...",
            creationCompanyUser: "Company/User Creation",
            evaluations: "Evaluations",
            officeScheduling: "Office Scheduling",
            queueManagement: "Queue Management",
            companyManagement: "Company Management",
            connectionManagement: "Connection Management",
            sendGreetingAccepted: "Send Greeting on Accepting Ticket",
            sendMsgTransfTicket: "Send Transfer Message between Departments/Agents",
            checkMsgIsGroup: "Ignore Group Messages",
            chatBotType: "Bot Type",
            userRandom: "Random Agent Selection",
            buttons: "Buttons",
            acceptCallWhatsapp: "Notify that WhatsApp call is not accepted?",
            sendSignMessage: "Allow agent to choose to send Signature",
            sendGreetingMessageOneQueues: "Send Greeting when only one queue exists",
            sendQueuePosition: "Send Queue Position Message",
            sendFarewellWaitingTicket: "Send Farewell Message while Waiting",
            acceptAudioMessageContact: "Accept Audio Messages from All Contacts?",
            enableLGPD: "Enable LGPD Processing",
            requiredTag: "Required Tag to Close Ticket",
            closeTicketOnTransfer: "Close Ticket when Transferring to Another Queue",
            DirectTicketsToWallets: "Automatically Move Client to Wallet",
            showNotificationPending: "Show Notification for Pending Tickets",
            copyContactPrefix: "Contact Copy Prefix",
            copyContactPrefixPlaceholder: "Ex: COPY_",
          },
          customMessages: {
            sendQueuePositionMessage: "Queue Position Message",
            AcceptCallWhatsappMessage: "Message to Inform Call Not Accepted",
            greetingAcceptedMessage: "Greeting Message When Accepting Ticket",
            transferMessage: "Transfer Message - ${queue.name} = destination queue",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Welcome Message (LGPD)",
            linkLGPD: "Privacy Policy Link",
            obfuscateMessageDelete: "Obfuscate Deleted Message",
            alwaysConsent: "Always Request Consent",
            obfuscatePhoneUser: "Obfuscate User Phone Number",
            enabled: "Enabled",
            disabled: "Disabled",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Assigned to:",
          dialogRatingTitle: "Would you like to leave a service rating for the client?",
          dialogClosingTitle: "Closing the service with the client!",
          dialogRatingCancel: "Resolve WITH Farewell Message",
          dialogRatingSuccess: "Resolve and Send Rating",
          dialogRatingWithoutFarewellMsg: "Resolve WITHOUT Farewell Message",
          ratingTitle: "Choose a rating menu",
          notMessage: "No message selected",
          amount: "Prospecting Value",
          buttons: {
            return: "Return",
            resolve: "Resolve",
            reopen: "Reopen",
            accept: "Accept",
            rating: "Send Rating",
            enableIntegration: "Enable Integration",
            disableIntegration: "Disable Integration",
            logTicket: "Ticket Logs",
            requiredTag: "You must assign a tag before closing the ticket.",
            greetingAcceptedMessage: "You must configure a greeting message when accepting the ticket.",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage: "Type a message or press / for quick replies",
        placeholderOpen: "Type a message or press / for quick replies",
        placeholderClosed: "Reopen or accept this ticket to send a message.",
        signMessage: "Sign",
        privateMessage: "Private Message",
      },
      contactDrawer: {
        header: "Contact Details",
        buttons: {
          edit: "Edit Contact",
          block: "Block",
          unblock: "Unblock",
        },
        extraInfo: "Additional Information",
      },
      messageVariablesPicker: {
        label: "Available Variables",
        vars: {
          contactFirstName: "First Name",
          contactName: "Name",
          user: "Agent",
          greeting: "Greeting",
          protocolNumber: "Protocol Number",
          date: "Date",
          hour: "Hour",
          ticket_id: "Ticket Number",
          queue: "Sector",
          connection: "Connection",
          scheduledDate: "Scheduled Date",
        },
      },
      ticketOptionsMenu: {
        schedule: "Schedule",
        delete: "Delete",
        transfer: "Transfer",
        registerAppointment: "Contact Notes",
        resolveWithNoFarewell: "Resolve without Farewell",
        acceptAudioMessage: "Accept audio messages from contact?",
        appointmentsModal: {
          title: "Ticket Notes",
          textarea: "Note",
          placeholder: "Enter the information you want to register here",
        },
        confirmationModal: {
          title: "Delete the contact's ticket",
          titleFrom: "from contact",
          message: "Attention! All messages related to this ticket will be lost.",
        },
        buttons: {
          delete: "Delete",
          cancel: "Cancel",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Enable/Disable Signature",
          privateMessage: "Enable/Disable Private Message",
          meet: "Send video conference link",
        },
        type: {
          imageVideo: "Photos and Videos",
          cam: "Camera",
          contact: "Contact",
          meet: "Video Call",
          template: "Meta Template",
        },
        upload: {
          uploading: "Uploading... {{percent}}%",
          finishing: "Sending to WhatsApp...",
          tooLarge: "{{category}} is too large ({{size}} MB). WhatsApp's maximum: {{limit}} MB.",
          category: {
            image: "Image",
            video: "Video",
            audio: "Audio",
            document: "Document",
          },
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancel",
        },
      },
      messageOptionsMenu: {
        delete: "Delete",
        reply: "Reply",
        edit: "Edit",
        forward: "Forward",
        toForward: "Forward",
        talkTo: "Talk To",
        confirmationModal: {
          title: "Delete message?",
          message: "This action cannot be undone.",
        },
      },
      invoices: {
        table: {
          invoices: "Invoices",
          details: "Details",
          users: "Users",
          connections: "Connections",
          queue: "Queues",
          value: "Value",
          expirationDate: "Expiration Date",
          action: "Action",
        },
      },
      backendErrors: {
        ERR_NO_FILE_UPLOADED: "No file uploaded.",
        ERR_AI_KNOWLEDGE_FILE_MUST_BE_PDF: "The file must be a PDF.",
        ERR_AI_KNOWLEDGE_FILE_TOO_LARGE: "The file exceeds the 5MB limit.",
        ERR_AI_KNOWLEDGE_MISSING_PARAMS: "Missing information to upload the file. Save the node before attaching PDFs.",
        ERR_NO_AI_KNOWLEDGE_FILE_FOUND: "File not found.",
        ERR_TICKETNOTE_INVALID_NAME: "Comment must be at least 3 characters long.",
        ERR_NO_OTHER_WHATSAPP: "There must be at lest one default WhatsApp connection.",
        ERR_NO_DEF_WAPP_FOUND: "No default WhatsApp found. Check connections page.",
        ERR_WAPP_NOT_INITIALIZED: "This WhatsApp session is not initialized. Check connections page.",
        ERR_WAPP_CHECK_CONTACT: "Could not check WhatsApp contact. Check connections page.",
        ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
        ERR_WAPP_DOWNLOAD_MEDIA: "Could not download media from WhatsApp. Check connections page.",
        ERR_INVALID_CREDENTIALS: "Authentication error. Please try again.",
        ERR_SENDING_WAPP_MSG: "Error sending WhatsApp message. Check connections page.",
        ERR_DELETE_WAPP_MSG: "Couldn't delete message from WhatsApp.",
        ERR_DELETE_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "Deleting messages is not supported on Official API (Meta) connections — Meta doesn't allow this action.",
        ERR_EDITING_WAPP_MSG_OFICIAL_NOT_SUPPORTED: "Editing messages is not supported on Official API (Meta) connections — Meta doesn't allow this action.",
        ERR_OTHER_OPEN_TICKET: "There's already an open ticket for this contact.",
        ERR_SESSION_EXPIRED: "Session expired. Please login.",
        ERR_USER_CREATION_DISABLED: "User creation was disabled by administrator.",
        ERR_NO_PERMISSION: "You don't have permission to access this resource.",
        ERR_DUPLICATED_CONTACT: "A contact with this number already exists.",
        ERR_NO_SETTING_FOUND: "No setting found with this ID.",
        ERR_NO_CONTACT_FOUND: "No contact found with this ID.",
        ERR_INVALID_COUNTRY_CODE: "Invalid country code.",
        ERR_NO_TICKET_FOUND: "No ticket found with this ID.",
        ERR_FLOW_NOT_FOUND: "Flow not found.",
        ERR_NO_USER_FOUND: "No user found with this ID.",
        ERR_NO_WAPP_FOUND: "No WhatsApp found with this ID.",
        ERR_CREATING_MESSAGE: "Error while creating message on database.",
        ERR_CREATING_TICKET: "Error while creating ticket on database.",
        ERR_FETCH_WAPP_MSG: "Error fetching the message in WhtasApp, maybe it is too old.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "This color is already in use, pick another one.",
        ERR_WAPP_GREETING_REQUIRED: "Greeting message is required if there is more than one queue.",
        ERR_OUT_OF_HOURS: "Outside Business Hours!",
        ERR_INVALID_PASSWORD: "Password must contain uppercase, lowercase, numbers and special characters.",
        ERR_INVALID_RESET_CODE: "Invalid verification code.",
        ERR_RESET_CODE_EXPIRED: "Verification code expired. Request a new one.",
        ERR_LIMIT_EXCEEDED: "Too many attempts. Please wait a few minutes.",
        ERR_MISSING_EMAIL: "Email is required.",
        ERR_MISSING_RESET_PARAMS: "Please fill in all fields.",
        ERR_CANNOT_REMOVE_GROUP_ADMIN: "Cannot remove the group administrator.",
        ERR_CHATBOT_NOT_FOUND_SERVICE: "Chatbot service not found.",
        ERR_CHAT_IS_NOT_GROUP: "This chat is not a group.",
        ERR_CHAT_NOT_FOUND: "Chat not found.",
        ERR_CHECK_NUMBER: "Could not verify the number. Please check and try again.",
        ERR_CODE_EXPIRED: "Verification code expired.",
        ERR_COGNITO_AUTH_FAILED: "Authentication failed. Please try again.",
        ERR_COGNITO_UPDATE_EMAIL: "Error updating email. Please try again.",
        ERR_EMAIL_ALREADY_IN_USE: "This email is already registered. Please use a different email address.",
        ERR_COGNITO_UPDATE_PASSWORD: "Error updating password. Please try again.",
        ERR_COGNITO_USER_ALREADY_EXISTS: "A user with this email already exists.",
        ERR_COMPANY_INACTIVE: "Your plan has expired. Choose a plan to continue.",
        ERR_COMPANY_INVALID_NAME: "Enter a valid company name (minimum 2 characters).",
        ERR_COGNITO_USER_CREATION: "Error creating user account. Please try again.",
        ERR_COGNITO_USER_CREATION_NO_SUB: "Error creating user account. Please contact support.",
        ERR_CONTACT_NOT_FOUND: "Contact not found.",
        ERR_DUPLICATED_FINALIZATION_REASON: "This finalization reason already exists.",
        ERR_EDITING_WAPP_MSG: "Error editing WhatsApp message.",
        ERR_EMPTY_MESSAGE: "Message cannot be empty.",
        ERR_FINALIZATION_REASON_NOT_FOUND: "Finalization reason not found.",
        ERR_FORBIDDEN_ACK_TARGET_COMPANY: "You don't have permission for this action.",
        ERR_GROUP_MUST_HAVE_AT_LEAST_2_USERS: "A group must have at least 2 users.",
        ERR_INVALID_MEDIA_TYPE: "Invalid media type. Supported types: image, audio, video and document.",
        ERR_INVALID_NUMBER: "Invalid number. Please check and try again.",
        ERR_INVALID_PARAMETER: "Invalid parameter.",
        ERR_INVALID_TOTP_CODE: "Invalid verification code. Please check and try again.",
        ERR_MFA_NOT_CONFIGURED: "Two-factor authentication is not configured for this account.",
        ERR_MFA_SETUP_FAILED: "Error setting up two-factor authentication. Please try again.",
        ERR_MISSING_CHALLENGE_PARAMS: "Missing required parameters. Please try again.",
        ERR_MISSING_CREDENTIALS: "Email and password are required.",
        ERR_MISSING_NEW_PASSWORD: "New password is required.",
        ERR_MISSING_REFRESH_PARAMS: "Missing required parameters to refresh session.",
        ERR_MISSING_TOTP_CODE: "Verification code is required.",
        ERR_NO_ANNOUNCEMENT_FOUND: "Announcement not found.",
        ERR_NO_BAILEYS_DATA_FOUND: "No WhatsApp session data found.",
        ERR_NO_CAMPAIGN_FOUND: "Campaign not found.",
        ERR_NO_CHATBOT_FOUND: "Chatbot not found.",
        ERR_NO_CHAT_FOUND: "Chat not found.",
        ERR_NO_COMPANY_FOUND: "Company not found.",
        ERR_NO_CONTACTLIST_FOUND: "Contact list not found.",
        ERR_NO_CONTACTLISTITEM_FOUND: "Contact list item not found.",
        ERR_NO_DIALOG_CHATBOT_FOUND: "Chatbot dialog not found.",
        ERR_NO_DIALOG_FOUND: "Dialog not found.",
        ERR_NO_FILE_FOUND: "File not found.",
        ERR_NO_HELP_FOUND: "Help article not found.",
        ERR_NO_INTEGRATIONS_FOUND: "Integration not found.",
        ERR_NO_INVOICE_FOUND: "Invoice not found.",
        ERR_NO_PARTNER_FOUND: "Partner not found.",
        ERR_NO_PLAN_FOUND: "Plan not found.",
        ERR_NO_PROMPT_FOUND: "Prompt not found.",
        ERR_NO_QUICKMESSAGE_FOUND: "Quick message not found.",
        ERR_NO_RATING_FOUND: "Rating not found.",
        ERR_NO_SCHEDULE_FOUND: "Schedule not found.",
        ERR_NO_TAG_FOUND: "Tag not found.",
        ERR_NOT_FOUND_USER_IN_QUEUE: "User not found in queue.",
        ERR_NO_TICKETNOTE_FOUND: "Ticket note not found.",
        ERR_NOT_MESSAGE_TO_IMPORT: "No messages to import.",
        ERR_NO_USERS_IN_QUEUE: "No users available in this queue.",
        ERR_PASSWORD_RESET_REQUIRED: "Password reset required. Please reset your password.",
        ERR_QUEUE_NOT_FOUND: "Queue not found.",
        ERR_REFRESH_FAILED: "Session refresh failed. Please login again.",
        ERR_SENDING_FACEBOOK_MSG: "Error sending Facebook message. Check connections page.",
        ERR_SENDING_WAPP_MSG_GROUP_BLOCKED: "This group has been blocked. Cannot send messages.",
        ERR_TEST_REPLY_DIALOG: "Error testing chatbot reply dialog.",
        ERR_TEST_SESSION_DIALOG: "Error testing chatbot session dialog.",
        ERR_UNSUPPORTED_CHALLENGE: "Unsupported authentication challenge. Please contact support.",
        ERR_USER_NOT_CONFIRMED: "User account is not confirmed. Please check your email.",
        ERR_USER_NOT_FOUND: "User not found.",
        ERR_USER_QUEUE_NOT_FOUND: "User queue not found.",
        ERR_PLAN_NOT_FOUND: "Plan not found.",
        ERR_PLAN_IS_TRIAL_USE_TRIAL_FLOW: "This plan is for trial only.",
        ERR_PLAN_INVALID_AMOUNT: "Invalid plan price. Contact support.",
        ERR_INVALID_PAYMENT_FLOW: "Invalid payment method.",
        ERR_PLAN_PAYMENT_METHOD_NOT_ALLOWED: "This payment method is not available for the selected plan.",
        ERR_PLAN_NAME_RECURRENCE_UNPARSEABLE: "Plan configuration error. Contact support.",
        ERR_PLAN_NAME_BILLING_UNPARSEABLE: "Plan configuration error. Contact support.",
        ERR_ASAAS_FIRST_PAYMENT_NO_INVOICE_URL: "Error generating payment. Try again.",
        ERR_ASAAS_BAD_REQUEST: "We couldn't generate your payment. Check your details and try again.",
        ERR_ASAAS_UNAUTHORIZED: "Payment gateway configuration error. Contact support.",
        ERR_ASAAS_HTTP_ERROR: "Payment gateway is unavailable. Please try again in a few minutes.",
        ERR_ASAAS_NETWORK: "Could not reach the payment gateway. Please try again.",
        ERR_ASAAS_API_KEY_MISSING: "Payment gateway configuration error. Contact support.",
        ERR_ASAAS_CALLBACK_DOMAIN_NOT_REGISTERED: "The redirect domain is not registered with the payment gateway. Contact support.",
        ERR_SIGNUP_ASAAS_FAILED: "Error creating account. Try again.",
        ERR_INVALID_INSTALLMENT_COUNT: "Invalid number of installments for this plan.",
        ERR_INSTALLMENT_LOCK_IN_EFFECT: "You still have ongoing installments on your current plan. Wait until they finish before switching plans.",
        ERR_ACTIVE_PLAN_SWITCH_BLOCKED: "You already have an active plan. Wait until your current term ends to switch plans.",
        ERR_NO_RECURRING_RESOURCE_TO_CANCEL: "There is no auto-renewal to cancel on this plan.",
        ERR_COMPANY_ALREADY_INACTIVE: "Your subscription is already inactive.",
        ERR_SUBSCRIPTION_ALREADY_ACTIVE: "Your subscription is already active. No reactivation needed.",
        ERR_NO_CREDIT_CARD_TOKEN_TO_REACTIVATE: "No saved credit card available to reactivate. Wait for the term to end and pick a new plan.",
        ERR_REACTIVATE_NOT_SUPPORTED_FOR_SUBSCRIPTION: "Automatic reactivation is not available for this plan. Wait for the term to end and pick a new plan.",
        ERR_COMPANY_NOT_FOUND: "Company not found.",
        ERR_BILLING_ADMIN_ONLY: "Only administrators can manage the company subscription.",
        ERR_INVOICE_NOT_PENDING: "The reminder can only be sent for pending invoices that aren't due yet.",
        ERR_INVOICE_ASAAS_LINKED_CANNOT_MANUALLY_EDIT: "This invoice is linked to a real Asaas charge — its status is updated automatically by Asaas and can't be changed manually.",
        ERR_INVOICE_INVALID_STATUS_TRANSITION: "That status change isn't allowed from this invoice's current status.",
        ERR_COMPANY_NO_EMAIL: "This company doesn't have an email on file.",
        ERR_MISSING_PAYMENT_FLOW: "Select a payment method to continue.",
        ERR_PLAN_IS_TRIAL: "This is a trial plan and cannot be purchased. Choose a paid plan to continue.",
        ERR_PLAN_NOT_INSTALLMENT: "This plan does not support installments.",
        ERR_INVALID_COMPANY_ID: "Invalid company identifier.",
        ERR_INVALID_INSTALLMENT_INPUT: "Invalid installment count.",
        ERR_BULK_DELETE_NO_IDS: "Select at least one company to delete.",
        ERR_BULK_DELETE_NO_VALID_IDS: "None of the selected companies can be deleted.",
        ERR_BULK_DELETE_PROTECTED_COMPANY: "Cannot delete a protected company.",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Method:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization: "Authorization Bearer (registered token) and Content-Type (application/json)",
        body: "Body:",
        fieldNumber: "\"number\": \"558599999999\"",
        fieldBody: "\"body\": \"Message\"",
        fieldUserId: "\"userId\": User ID or \"\"",
        fieldQueueId: "\"queueId\": Queue ID or \"\"",
        fieldSendSignature: "\"sendSignature\": Sign message - true/false",
        fieldCloseTicket: "\"closeTicket\": Close the ticket - true/false",
        singMessage: "Sign message - true/false",
        closeTicket: "Close the ticket - true/false",
        testSend: "The Test Send",
      },
      recurrenceSection: {
        title: "Recurrence",
        description: "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Interval filter value",
        sendAsManyTimes: " Send as many times",
        shipNormallyOnNonbusinessDays: "Ship normally on non-business days",
        sendOneBusinessDayBefore: "Send one business day before",
        sendOneBusinessDayLater: "Send one business day later",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
        servicePanel: {
          allowRealTime: "Service Panel",
        },
      },
      servicePanel: {
        allowRealTime: "Service Panel  ",
      },
      financial: {
        invoices: "Invoices",
        details: "Details",
        users: "Users",
        connections: "Connections",
        queues: "Queues",
        value: "Value",
        expirationDate: "Due Date",
        status: "Status",
        action: "Action",
      },
      statusFilter: {
        statusFilter: "Filter by Status",
      },
      momentsUser: {
        services: "Services:",
        pending: "Pending",
        noqueue: "NO QUEUE",
      },
      campaignsPhrase: {
        campaignsFlow: "Campaigns Flow",
        campaigns: "Campaign",
        name: "Name",
        status: " Status",
        newCampaignWithFlowByPhrase: "New campaign with flow by phrase",
        editCampaignWithFlowByPhrase: "Edit campaign with flow by phrase",
        phraseTriggerName: "Phrase trigger name",
        chooseAStream: "Choose a stream",
        whichPhraseTriggersTheFlow: " Which phrase triggers the flow?",
        selectAConnection: " Select a Connection",
        cancel: "CANCEL",
        createCampaign: "CREATE CAMPAIGN ",
        saveCampaign: "Sale Campaign",
      },
      chatList: {
        noMessages: "No messages",
        admin: "Admin",
        member: "Member",
        searchChat: "Search chat...",
        createNewChat: "Create new chat",
        searchUser: "Search user...",
        noUserFound: "No user found",
        noUserAvailable: "No user available",
        cancel: "Cancel",
        details: "Details",
        deleteChat: "Delete Chat",
        deleteChatConfirm: "This action cannot be undone, confirm?",
        detailsTitle: "Details",
        edit: "Edit",
        delete: "Delete",
        now: "now",
        minutesAgo: "{{count}}m ago",
        hoursAgo: "{{count}}h ago",
      },
      chatMessages: {
        deleted: "This message was deleted",
        deletedAdmin: "Deleted message - visible only to administrators",
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        editMessage: "Edit Message",
        save: "Save",
        cancel: "Cancel",
        deleteMessage: "Delete Message",
        deleteMessageConfirm: "Are you sure you want to delete this message?",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        doubleClickToReply: "Double click to reply",
        edited: "(edited)",
        forwarded: "(forwarded)",
        typeMessage: "Type a message...",
        send: "Send",
        noMessages: "No messages",
        loading: "Loading...",
        replyingTo: "Replying to",
        clickToGoToOriginal: "Click to go to original message",
      },
      chatPopover: {
        reply: "Reply",
        edit: "Edit",
        delete: "Delete",
        forward: "Forward",
        cancel: "Cancel",
        confirmDelete: "Confirm Delete",
        confirm: "Confirm",
        deleteMessage: "Are you sure you want to delete this message?",
        editMessage: "Edit Message",
        save: "Save",
        forwardMessage: "Forward Message",
        selectChat: "Select chat",
        noChats: "No chat available",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Groups",
        new: "New",
        messages: "Messages",
        search: "Search...",
        noChats: "No chat found",
        noGroups: "No group found",
        noMessages: "No messages",
        loading: "Loading...",
        error: "Error loading data",
        addGroupPhoto: "Add Group Photo",
        changeGroupPhoto: "Change Group Photo",
        groupName: "Group Name",
        groupDescription: "Group Description",
        save: "Save",
        cancel: "Cancel",
        createGroup: "Create Group",
        groupCreated: "Group created successfully",
        editGroup: "Edit Group",
        deleteGroup: "Delete Group",
        deleteGroupConfirm: "Are you sure you want to delete this group?",
        edit: "Edit",
        delete: "Delete",
        details: "Details",
        groupDetails: "Group Details",
        title: "Title",
        description: "Description",
        modal: {
          title: "Create Group",
          editTitle: "Edit Group",
          save: "Save",
          cancel: "Cancel",
          name: "Group Name",
          description: "Group Description",
          create: "Create",
          edit: "Edit",
        },
      },
      whitelabel: {
        primaryColorLight: "Primary Color (Light Theme)",
        primaryColorDark: "Primary Color (Dark Theme)",
        appName: "Application Name",
        logoLight: "Logo (Light Theme)",
        logoDark: "Logo (Dark Theme)",
        favicon: "Favicon",
        backgroundLight: "Background Image (Light Theme)",
        backgroundDark: "Background Image (Dark Theme)",
        preview: "Preview",
        delete: "Delete",
        upload: "Upload",
        availableLanguages: "Available Languages",
        atLeastOneLanguage: "At least one language must be enabled",
        sections: {
          general: "General Settings",
          generalDescription: "Configure the application name and basic information",
          colors: "Colors and Themes",
          colorsDescription: "Customize primary colors for light and dark themes",
          logos: "Logos and Images",
          logosDescription: "Upload application logos and background images",
          languages: "Available Languages",
          languagesDescription: "Select which languages will be available in the system",
        },
      },
      contactList: {
        dialog: "Contact List",
      },
      frontEndErrors: {
        getUsers: "Error loading users",
      },
      loading: "Loading...",
      messageModal: {
        success: {
          save: "Message saved successfully!",
        },
        title: {
          add: "Add Message",
          edit: "Edit Message",
        },
      },
      quickemessages: {
        toasts: {
          deleted: "Quick message deleted!",
        },
      },
      ticketInfo: {
        invalidPhoneFormat: "Invalid phone format",
        copyError: "Error copying phone number",
        copyPhone: "Copy phone number",
        noPhone: "No phone number available to copy",
        phonecopied: "Phone number copied to clipboard!",
        quickMessages: "Quick Messages",
      },
      ticketList: {
        success: {
          integrationTriggered: "Integration triggered successfully!",
        },
      },
      webhookModal: {
        saveSuccess: "Webhook saved successfully!",
        title: {
          add: "Add Webhook",
          edit: "Edit Webhook",
        },
        toasts: {
          update: "Webhook updated successfully!",
        },
      },
      triggerFlowModal: {
        cancel: "Cancel",
        description: "Select a flow to execute on this ticket. The ticket status will change to 'chatbot' during execution.",
        flowId: "Flow ID",
        noFlows: "No active flows found",
        selectFlow: "Choose a flow",
        selectedFlow: "Selected flow",
        title: "Trigger Flow",
        trigger: "Trigger Flow",
        triggering: "Triggering...",
      },
      whatsappModalRel: {
        form: {
          elementNotFoundForExport: "Element not found for export.",
          reportFilename: "support_report",
        },
      },
      chatBots: {
        confirmDeleteAll: "Are you sure? All internal options will also be deleted.",
      },
      contactImport: {
        title: "Export / Import Contacts",
      },
      platforms: {
        gclick: {
          tabs: {
            aiAgent: "A.I. Agent",
            app: "Application",
          },
        },
        table: {
          selected: "{{count}} selected",
          delete: {
            dialogTitle: "Delete integration?",
            toastSuccess: "Integration deleted successfully.",
            message:
              "the saved credentials will be erased. The company's access stays enabled, so you can set it up again at any time.",
          },
          bulkDelete: {
            button: "Delete Selected ({{count}})",
            dialogTitle: "Delete {{count}} selected integration(s)?",
            dialogMessage:
              "The saved credentials will be erased. The company's access stays enabled, so it can be set up again at any time.",
            confirmWord: "DELETE",
            andMore: "and {{count}} more",
            confirmLabel: "Type {{word}} to confirm",
            toastSuccess: "{{count}} integration(s) deleted successfully.",
            toastPartial:
              "{{deleted}} deleted, {{failed}} failed. The failed ones remain selected.",
          },
        },
      },
    },
  },
};

export { messages };
